var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32802",
    "data-name": "Path 32802",
    d: "M0,0H48V48H0Z",
    fill: "#c7cdd1",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report_card_as_lost_or_stolen",
    "data-name": "Report card as lost or stolen",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29590",
    "data-name": "Group 29590",
    transform: "translate(10.23 12.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29589",
    "data-name": "Group 29589",
    transform: "translate(12.754 9.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32799",
    "data-name": "Path 32799",
    d: "M651.007,1029.818a1.434,1.434,0,0,1,.451,1.057,1.455,1.455,0,0,1-.451,1.067,1.438,1.438,0,0,1-1.048.448,1.51,1.51,0,1,1,0-3.02A1.438,1.438,0,0,1,651.007,1029.818Z",
    transform: "translate(-648.44 -1020.68)",
    fill: "#102d6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32800",
    "data-name": "Path 32800",
    d: "M648.44,1020.8h3.017l-.5,7.6h-2.008Z",
    transform: "translate(-648.44 -1020.8)",
    fill: "#102d6f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_32801",
    "data-name": "Path 32801",
    d: "M663.681,1033.99l-12.3-21.97a1.942,1.942,0,0,0-3.4,0l-12.294,21.97a2.108,2.108,0,0,0-.265.99,2,2,0,0,0,1.959,2.01h24.6a1.942,1.942,0,0,0,.97-.27A2.024,2.024,0,0,0,663.681,1033.99Zm-11.882-.88a2.828,2.828,0,0,1-2.106.93,2.876,2.876,0,0,1-2.135-.93,3.155,3.155,0,0,1-.206-4.07,1.984,1.984,0,0,1-.137-.54l-.509-7.6a1.514,1.514,0,0,1,.392-1.12,1.447,1.447,0,0,1,1.078-.48h3.017a1.453,1.453,0,0,1,1.068.47,1.5,1.5,0,0,1,.392,1.13l-.49,7.6a1.475,1.475,0,0,1-.147.55,3.127,3.127,0,0,1-.215,4.06Z",
    transform: "translate(-635.42 -1011.016)",
    fill: "#ffb063"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.29cf39b8f71d4aad4f07240dc86f21f3.svg";
export { ForwardRef as ReactComponent };